import { useStaticQuery } from "gatsby";
const useGetLogo = () => { const { logo } = useStaticQuery("436590876"); return { logo: logo.publicURL }; };
export default useGetLogo;
